<template>
  <div id="content" :class="{ light: !darkMode }">
    <Background />
    <Menu />
    <router-view></router-view>
    <Settings />
    <div id="blur" v-if="showSafariPopUp" />
    <div
      v-if="showSafariPopUp"
      id="safari-info"
      :class="{ light: !darkMode }"
      @click="showSafariPopUp = false"
    >
      <div id="safari-head" :class="{ light: !darkMode }">
        <div class="title2 title">{{ $t("safari.title") }}</div>
        <div id="safari-close" class="text">X</div>
      </div>
      <div class="text" v-html="$t('safari.text')"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import store from "@/store";
import Settings from "./components/Settings.vue";
import Background from "./components/Background.vue";
import Menu from "./components/Menu.vue";

export default defineComponent({
  name: "App",
  components: {
    Settings,
    Menu,
    Background,
  },
  data(): { showSafariPopUp: boolean } {
    return {
      showSafariPopUp: true,
    };
  },
  computed: {
    darkMode() {
      return store.state.darkMode;
    },
  },
  mounted() {
    this.detectSafari();
  },
  methods: {
    detectSafari() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isSafari = /^((?!chrome|android).)*safari/.test(userAgent);
      this.showSafariPopUp = isSafari;
    },
  },
});
</script>

<style>
#content {
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  margin: 20px;
  border: 1px solid white;
  position: relative;
}

#content.light {
  border-color: #212121;
}

html {
  height: 100%;
  width: 100%;
}

body {
  height: 100%;
  width: 100%;
  margin: 0;
}

#blur {
  position: absolute;
  z-index: 190;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(4px);
}

#safari-info {
  position: absolute;
  left: 10%;
  top: 10%;
  z-index: 200;
  width: calc(80% - 22px);
  border: solid 1px #ececec;
  border-radius: 5px;
  background-color: rgba(33, 33, 33, 0.9);
  backdrop-filter: blur(4px);
  padding: 10px;
}

#safari-info.light {
  border-color: #212121;
  background-color: rgba(236, 236, 236, 0.9);
}

#safari-head {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: solid 1px rgb(236, 236, 236);
  width: 100%;
  padding-bottom: 5px;
  margin-bottom: 10px;
  position: relative;
}

#safari-head.light {
  border-color: rgb(33, 33, 33);
}

#safari-close {
  position: absolute;
  top: -2px;
  right: 0px;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}

@media screen AND (hover: hover) AND (pointer: fine) {
  #safari-info:hover {
    cursor: pointer;
  }

  #safari-close:hover {
    opacity: 0.25;
  }
}

@media (min-width: 768px) {
  #content {
    width: calc(100% - 60px);
    height: calc(100% - 60px);
    margin: 30px;
  }

  #safari-info {
    border-radius: 10px;
    padding: 20px;
    width: calc(60% - 40px);
    left: 20%;
    top: 20%;
  }

  #safari-head {
    padding-bottom: 10px;
  }

  #safari-close {
    top: -4px;
  }
}

@media (min-width: 768px) AND (orientation: landscape) {
  #safari-info {
    width: calc(40% - 40px);
    left: 30%;
  }
}
</style>
